<template>
  <v-row
    no-gutters
    class="Home">
    <v-container>
      <v-layout
        fill-height
        align-center
        justify-center>
        <v-flex
          xs11
          sm10
          md9
          lg8>
          <h1
            :class="isEmbedded ? 'display-2' : 'display-3'"
            class="font-weight-bold text-xs-center my-3">
            Schedule meetings without the back-and-forth emails
            <img
              :height="isEmbedded ? '48px' : '64px'"
              src="/assets/calendar.png"
              class="d-inline hidden-xs-only">
          </h1>
          <v-divider class="mt-6" />
          <p class="title font-weight-regular mt-9 mb-3 grey--text text--darken-2 mx-auto d-block">Schedule meetings right from your inbox. Gmelius meeting scheduler integrates with your favorite tools.</p>
          <v-layout
            justify-center
            class="mt-6">
            <img
              :height="isEmbedded ? '50px' : '85px'"
              src="/assets/gmail.png"
              class="d-inline mr-8">
            <img
              :height="isEmbedded ? '50px' : '85px'"
              src="/assets/gcalendar.png"
              class="d-inline mr-6">
            <img
              :height="isEmbedded ? '50px' : '85px'"
              src="/assets/meet.png"
              class="d-inline mr-6">
            <img
              :height="isEmbedded ? '50px' : '85px'"
              src="/assets/zoom-logo.png"
              class="d-inline">
          </v-layout>
          <v-divider class="mt-10 mb-6" />
          <v-layout
            row
            justify-center>
            <v-btn
              :href="externalLinks.dashboardUrl"
              color="primary"
              rounded
              x-large
              ripple
              class="text-none font-weight-bold icon-google pl-12 mx-2 mt-4">
              <span class="ml-2">
                {{ $t('booked.create') }}
              </span>
            </v-btn>

            <v-btn
              color="grey"
              rounded
              x-large
              text
              ripple
              class="text-none font-weight-medium mx-2 mt-4"
              href="https://gmelius.com/meeting-scheduler">
              <span class="ml-2">
                {{ $t('booked.learnMore') }}
              </span>
            </v-btn>
          </v-layout>
          <v-layout
            class="caption grey--text mt-12"
            justify-center>
            &copy; {{ new Date().getFullYear() }} Gmelius. work together. everywhere!
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-row>
</template>

<script>
import { localeMixin } from '../mixins'
import { externalLinks } from '../config'

export default {
  mixins: [localeMixin],
  data () {
    return {
      isEmbedded: null,
      windowWidth: window.innerWidth,
      externalLinks
    }
  },
  watch: {
    windowWidth (newHeight, oldHeight) {
      this.isEmbedded = newHeight < 500 ? '1' : null
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.embed) {
      this.isEmbedded = this.$route.query.embed
    } else {
      this.isEmbedded = window.innerWidth < 500 ? '1' : null
    }
    window.addEventListener('resize', () => {
      this.updateScreenSize(window.innerWidth)
    })
  },
  methods: {
    installGmelius () {
      window.open(externalLinks.dashboardUrl, '_blank')
    },
    updateScreenSize (newWidth) {
      this.windowWidth = newWidth
    }
  }
}
</script>
<style lang="scss">
.Home {
  min-height:100vh;
  @media screen and (max-width: 800px) {
      background-image:none;
    }
  &__row {
    height: 100%;
    &--card {
      background-color: transparent !important;
    }
  }
}
</style>
